/**
 * The table's walnut and travertine, for the HTML pages around it, handed to
 * CSS as `--surface-wood`, `--surface-stone` and `--surface-grain`, so the start
 * page is laid on the table the game is played on.
 *
 * Wood and stone are the generated images the canvas uses (table/materials.ts),
 * so CSS is given the image files themselves. Anything painted from noise — the
 * grain, or a surface whose image did not load — takes a moment, so it happens
 * after the first frame: until then the stylesheet's flat colours stand in.
 */
import { artUrl, surfaceCanvas, type Surface } from './table/materials';

const NAMES: readonly Surface[] = ['stone', 'wood', 'grain'];

let started = false;

export function paintSurfaces(root: HTMLElement = document.documentElement): void {
  if (started) return;
  started = true;
  const paintOne = (k: number) => {
    const name = NAMES[k];
    if (!name) return;
    const url = name === 'grain' ? null : artUrl(name);
    if (url) {
      root.style.setProperty(`--surface-${name}`, `url(${url})`);
      paintOne(k + 1);
      return;
    }
    surfaceCanvas(name).toBlob((blob) => {
      if (blob) root.style.setProperty(`--surface-${name}`, `url(${URL.createObjectURL(blob)})`);
    });
    // One surface per frame, so the page never stalls for all three at once.
    window.setTimeout(() => paintOne(k + 1), 0);
  };
  window.requestAnimationFrame(() => window.setTimeout(() => paintOne(0), 0));
}
